module.exports = __webpack_public_path__ + "img/case_three.708ca9e8.png";